import { createApp } from 'vue';
import App from './components/App.vue';
import { router } from '../router/index.js';
import { registerSW } from 'virtual:pwa-register';

import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import Tooltip from 'primevue/tooltip';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';

import 'primeicons/primeicons.css';

import { VueFire, VueFireAuth } from 'vuefire';
import { firebaseApp } from './firebase/config.js';
import '../sass/app.scss';

const app = createApp(App);

app.use(VueFire, {
    firebaseApp,
    modules: [
        VueFireAuth()
    ]
});

app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: false,
        }
    }
});

app.use(ToastService);

app.directive('tooltip', Tooltip);
app.component('Toast', Toast);

app.use(router).mount('#app');

registerSW({ immediate: true });